import React from 'react';
import { Suggested, ReferenceData, Prompts, AttachFiles, LinkReferenceData, ContentModeration, AgentBuilder, DomainAgent } from '.';

const AgentBuilderForm = ({ onFormChange, initialData, colors, onColorChange, onSave, hasChanges }) => (
  <div className="w-full md:w-[400px] bg-white p-7 pr-1 h-[550px] flex flex-col">
    <div
      className="flex-1 overflow-y-auto custom-scrollbar pr-2"
      style={{ scrollbarGutter: 'stable' }}
    >
      <div className="flex flex-col gap-3">
        <AgentBuilder 
          onFormChange={onFormChange} 
          initialData={initialData}
          colors={colors}
          onColorChange={onColorChange}
          onSave={onSave}
          hasChanges={hasChanges}
        />
        <Suggested />
        <ReferenceData />
        <Prompts />
        <AttachFiles />
        <LinkReferenceData />
        <ContentModeration />
        <DomainAgent />
      </div>
    </div>
  </div>
);

export { AgentBuilderForm };
